<template>
  <div>
    <b-breadcrumb :items="items"></b-breadcrumb>
    <b-row class="mx-0 mb-3">
      <b-col lg="12">
        <b-card no-body class>
          <b-row>
            <b-col lg="12">
              <b-card
                title="Commissions sur vente"
                title-tag="h6"
                class="bg-light shadow"
              >
                <b-row>
                  <b-col lg="3">
                    <label>Sélectionnez un vendeur</label>
                    <b-select
                      class="mb-3"
                      v-model="vendeurSelected"
                      :options="vendeursOptions"
                      @change="loadCommissions(vendeurSelected)"
                    ></b-select>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="12">
                    <b-card
                      class="mb-3 bg-light shadow"
                      title-tag="h6"
                      title="Liste des commissions dues"
                    >
                      <div
                        v-for="(commission, index) in lazy(commissions)"
                        :key="index"
                      >
                        <h5 class="text-center">
                          {{ toMonth(commission.month) }}
                        </h5>
                        <b-table
                          striped
                          small
                          fixed
                          hover
                          :items="commission.factures"
                          :fields="commission_fields"
                        >
                          <template v-slot:cell(creancier)="data">
                            <b-link
                              :to="{
                                name: 'creditorView',
                                params: { id: data.item.creancierID },
                              }"
                            >
                              {{ data.item.creancier }}
                            </b-link>
                          </template>
                          <template v-slot:cell(ID)="data">
                            <a href="#" @click.prevent="editInvoice(data.item)">
                              {{ data.item.ID }}
                            </a>
                          </template>
                          <template v-slot:bottom-row>
                            <td />
                            <td />
                            <td />
                            <td />
                            <td>
                              <strong
                                >Total :<span class="float-right"
                                  >{{
                                    Number(
                                      totalHTVA(commission)
                                    ).toLocaleString(undefined, {
                                      minimumFractionDigits: 2,
                                    })
                                  }}
                                  €</span
                                ></strong
                              >
                            </td>
                            <td />

                            <td>
                              <strong
                                ><span class="float-right"
                                  >{{
                                    Number(
                                      totalCommission(commission)
                                    ).toLocaleString(undefined, {
                                      minimumFractionDigits: 2,
                                    })
                                  }}
                                  €</span
                                ></strong
                              >
                            </td>
                            <td>
                              <strong
                                ><span class="float-right"
                                  >{{
                                    Number(
                                      totalSolde(commission)
                                    ).toLocaleString(undefined, {
                                      minimumFractionDigits: 2,
                                    })
                                  }}
                                  €</span
                                ></strong
                              >
                            </td>
                          </template>
                        </b-table>
                        <hr />
                      </div>
                    </b-card>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
          </b-row>
          <b-modal
            id="modal-modifier-invoice"
            size="lg"
            title="Modifier une facture"
            hide-footer
          >
            <Invoice
              @change="loadCommissions(vendeurSelected)"
              @close="$bvModal.hide('modal-modifier-invoice')"
              :invoice_id="invoice_id"
            ></Invoice>
          </b-modal>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import sellers from "@/services/sellers.js";
import invoices from "@/services/invoices.js";
import Invoice from "@/components/Invoice";
import DateTime from "@/services/DateTime.js";
export default {
  name: "ManageCommission",
  components: {
    Invoice,
  },
  created() {
    this.loadCommissions(this.vendeurSelected);
    this.scroll();
  },
  methods: {
    totalHTVA(commission) {
      let total = 0;
      commission.factures.forEach((el) => {
        total += Number(el.prixHTVA);
      });
      return total;
    },
    totalCommission(commission) {
      let total = 0;
      commission.factures.forEach((item) => {
        total += Number(
          item.prixHTVA *
            Number(
              item.vendeur_commission == "0.00"
                ? item.vc / 100
                : item.vendeur_commission / 100
            )
        );
      });
      return total;
    },
    totalSolde(commission) {
      let total = 0;
      commission.factures.forEach((el) => {
        total += Number(el.solde);
      });
      return total;
    },
    lazy(table) {
      return table.slice(0, this.nTables);
    },
    loadCommissions(id) {
      const param = id === null ? "all" : id;
      sellers.commissions({ seller_id: param }).then((response) => {
        if (response.data.status == "success") {
          this.commissions = response.data.data.commissions;
          this.vendeursOptions = [
            {
              value: null,
              text: "Tous les vendeurs",
            },
            ...response.data.data.vendeurs,
          ];
        }
      });
    },
   
    editInvoice(payload) {
      this.invoice_id = payload.ID;
      this.$bvModal.show("modal-modifier-invoice");
    },
    deleteInvoice(payload) {
      invoices
        .delete_invoice({
          invoice_id: payload.ID,
        })
        .then((response) => {
          if (response.data.success) {
            this.loadCommissions(this.vendeurSelected);
          }
        });
    },
    scroll() {
      window.onscroll = () => {
        let bottomOfWindow =
          document.documentElement.scrollTop + window.innerHeight + 300 >
          document.documentElement.offsetHeight;
        //console.log(document.documentElement.scrollTop + window.innerHeight, document.documentElement.offsetHeight);
        if (bottomOfWindow) {
          if (this.nTables < this.commissions.length) {
            this.nTables++;
          }
        }
      };
    },
    toDate(d) {
      return DateTime.humanDate(d);
    },
    toMonth(d) {
      return DateTime.humanMonth(d);
    },
  },
  data() {
    return {
      Api: sellers,
      seller_id: null,
      invoice_id: null,
      commissions: [],
      nTables: 5,
      vendeursOptions: [],
      vendeurSelected: null,
      items: [
        {
          text: "Gestion",
          to: { name: "home" },
        },
      
        {
          text: "Commissions sur vente",
          active: true,
        },
      ],
      actions: [
        {
          label: "Éditer",
          event: "edit_seller",
          icon: "pencil-square",
          variant: "success",
        },

        {
          label: "Supprimer",
          event: "delete_seller",
          icon: "x-square-fill",
          variant: "danger",
          condition: () => this.$store.getters.isSuperAdmin
        },
      ],
      commission_fields: [
        {
          key: "ID",
          label: "Numéro",
          class: "text-center",
          thStyle: { width: "100px" },
        },
        {
          key: "vendeur_nom",
          label: "Vendeur",
          thStyle: { width: "15%" },
          sortable: true,
          formatter: (value, key, item) => {
            return item.vendeur_prenom + " " + item.vendeur_nom;
          },
        },
        {
          key: "date",
          label: "Date",
          class: "text-center",
          thStyle: { width: "100px" },
          formatter: (value) => this.toDate(value),
        },
        {
          key: "creancier",
          label: "Créancier",
          class: "text-truncated",
        },
        {
          key: "prixHTVA",
          label: "Prix HTVA",
          class: "text-right",
          thStyle: { width: "10%" },
          formatter: (value) => `${Number(value).toFixed(2)} €`,
        },
        {
          key: "vendeur_commission",
          label: "Comission",
          class: "text-right",
          thStyle: { width: "10%" },
          formatter: (value, key, item) =>
            value == "0.00"
              ? `${Number(item.vc).toFixed(0)} %`
              : `${Number(value).toFixed(0)} %`,
        },
        {
          key: "comm",
          label: "Commission HTVA",
          thStyle: { width: "10%" },
          class: "text-right",
          formatter: (value, key, item) =>
            `${Number(
              item.prixHTVA *
                Number(
                  item.vendeur_commission == "0.00"
                    ? item.vc / 100
                    : item.vendeur_commission / 100
                )
            ).toFixed(2)} €`,
        },
        {
          key: "solde",
          thStyle: { width: "10%" },
          label: "Solde",
          class: "text-right",
          formatter: (value) => `${Number(value).toFixed(2)} €`,
        },
      ],
      fields: [
        {
          key: "nom",
          label: "Nom",
          sortable: true,
          formatter: (value, key, item) => {
            return item.prenom + " " + item.nom;
          },
        },

        {
          key: "langue",
          label: "Langue",
          class: "text-center",
          sortable: true,
        },
        {
          key: "commission",
          label: "Commission",
          sortable: true,
          class: "text-center",
          formatter: (value) => {
            return value ? value + " %" : "";
          },
        },
        {
          key: "actions",
          label: "Actions",
          sortable: false,
          thStyle: "width:100px",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
</style>